import { createContext, useContext, useState } from "react";

const BillingGateContext = createContext();
const { Provider } = BillingGateContext;

export const BillingGateProvider = ({ children }) => {
  const [state, setState] = useState({
    loading: true,
    checked: false,
    accessAllowed: true,
  });

  return <Provider value={{ state, setState }}>{children}</Provider>;
};

export const useBillingGate = () => {
  const ctx = useContext(BillingGateContext);
  if (!ctx) throw new Error("useBillingGate must be used inside provider");
  return ctx;
};
